/* eslint-disable no-unused-vars */
import React from 'react';
import { useEffect, useRef } from 'react';

import { Dropdown } from 'antd';
import { Box, Divider, IconButton, Stack, Tooltip } from '@mui/material';

import '@react-pdf-viewer/zoom/lib/styles/index.css';
import '@react-pdf-viewer/print/lib/styles/index.css';
import '@react-pdf-viewer/full-screen/lib/styles/index.css';
import '@react-pdf-viewer/core/lib/styles/index.css';
import './PDF.scss';

import { Viewer, Worker } from '@react-pdf-viewer/core';
import { printPlugin } from '@react-pdf-viewer/print';
import { getFilePlugin } from '@react-pdf-viewer/get-file';
import { fullScreenPlugin } from '@react-pdf-viewer/full-screen';
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import { pageNavigationPlugin } from '@react-pdf-viewer/page-navigation';

import {
	DownloadOutlined,
	FullscreenOutlined,
	MenuUnfoldOutlined,
	PrinterOutlined,
	SwitcherOutlined,
	ZoomInOutlined,
	ZoomOutOutlined,
} from '@ant-design/icons';
import { API_PORT, DEPLOYENVIRONMENT } from 'apiConfig';

const PDFViewer = ({
	url,
	filePath,
	mode = 'Dochub',
	fileName,
	collapse,
	collapseHandler,
	files = [],
	selectedPDFIndex,
	setSelectedPDFIndex,
	filesDownloadAccess = true,
	accessToken,
}) => {
	console.log('filesDownloadAccess', filesDownloadAccess);
	const pdfPageRef = useRef(null);

	const fullScreenPluginInstance = fullScreenPlugin();
	const printPluginInstance = printPlugin();
	const getFilePluginInstance = getFilePlugin({
		fileNameGenerator: (file) => {
			// Safely get the default name if the prop is missing
			const defaultFileName = file?.name ? file?.name.substring(file?.name?.lastIndexOf('/') + 1) : 'document.pdf';
			return fileName || defaultFileName;
		},
	});
	const pageNavigationPluginInstance = pageNavigationPlugin();
	const zoomPluginInstance = zoomPlugin({
		enableShortcuts: false,
	});

	let fullURL;
	let currentPageUrl = window.location;

	const { Print } = printPluginInstance;
	const { Download } = getFilePluginInstance;
	const { EnterFullScreen } = fullScreenPluginInstance;
	const { CurrentScale, ZoomIn, ZoomOut } = zoomPluginInstance;
	const { NumberOfPages, CurrentPageInput } = pageNavigationPluginInstance;

	// const items = () => {
	// 	return files?.map((item, index) => {
	// 		if (index === 0) {
	// 			return { key: index, label: `Current Version` };
	// 		} else {
	// 			return { key: index, label: `Current Minus ${index}` };
	// 		}
	// 	});
	// };

	if (url) {
		fullURL = url;
	} else {
		let mainURLSplit = currentPageUrl.origin;

		if (currentPageUrl.hostname === 'localhost') {
			mainURLSplit = `https://${DEPLOYENVIRONMENT}api.garlicerp.com`;
		} else {
			if (DEPLOYENVIRONMENT !== '') mainURLSplit = `https://${DEPLOYENVIRONMENT}api.garlicerp.com`;
			else mainURLSplit = `https://api.garlicerp.com`;
		}

		let fileURLSplit = filePath;
		fullURL = mainURLSplit + `:${API_PORT}/resource-service/endpoint/dochub/global?resource=` + fileURLSplit;
	}

	const changePDFHandler = (e) => {
		setSelectedPDFIndex(e.key);
	};

	useEffect(() => {
		if (pdfPageRef?.current) {
			const pageInput = pdfPageRef?.current?.querySelector('input');

			if (pageInput) {
				pageInput.id = 'current_page';
			}
		}
	}, []);

	return (
		<Worker workerUrl={`https://${DEPLOYENVIRONMENT === '' ? 'www.' : DEPLOYENVIRONMENT}garlicerp.com/pdf.worker.min.js`}>
			<Stack
				sx={{
					width: '100%',
					// height: 'calc(100% - 53px)',
					height: '100%',
				}}
			>
				<Box
					sx={{
						...{
							borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
							padding: '17px 8px',
							width: '100%',
							fontSize: '16px',
						},
						...(mode === 'Dochub'
							? {
									position: 'sticky',
									top: 0,
									left: 0,
									zIndex: 1,
								}
							: {}),
					}}
				>
					<Stack direction="row" alignItems="center" justifyContent="space-between">
						{mode === 'Dochub' ? (
							<Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
								<Tooltip title={collapse ? 'Expand' : 'Collapse'} placement="top">
									<IconButton sx={{ width: '24px', height: '24px', fontSize: 'inherit' }} onClick={collapseHandler}>
										<MenuUnfoldOutlined />
									</IconButton>
								</Tooltip>
								{/* {files?.length > 0 && (
												<Dropdown
													menu={{
														items: items,
														onClick: changePDFHandler,
														selectable: true,
														defaultSelectedKeys: [`${selectedPDFIndex}`],
													}}
												>
													<Tooltip title="View Archived Versions" placement="top">
														<Stack direction="row" spacing={0.5} sx={{ cursor: 'pointer' }}>
															<SwitcherOutlined />
															<Box>Archive</Box>
														</Stack>
													</Tooltip>
												</Dropdown>
											)} */}
							</Stack>
						) : (
							<Box></Box>
						)}

						<Stack direction="row" divider={<Divider orientation="vertical" flexItem />}>
							<Box sx={{ px: 1, display: 'flex', alignItems: 'center' }} ref={pdfPageRef}>
								<CurrentPageInput />
								<Box sx={{ mx: '4px' }}>/</Box>
								<Box sx={{ mx: '4px' }}>
									<NumberOfPages />
								</Box>
							</Box>

							<Box sx={{ px: 1, display: 'flex', alignItems: 'center' }}>
								<ZoomOut>
									{(props) => (
										<Tooltip title="zoom out" placement="top">
											<IconButton sx={{ width: '24px', height: '24px', fontSize: 'inherit' }} onClick={props.onClick}>
												<ZoomOutOutlined />
											</IconButton>
										</Tooltip>
									)}
								</ZoomOut>

								<CurrentScale>
									{(props) => <Box component="span" sx={{ px: '5px' }}>{`${Math.round(props.scale * 100)}%`}</Box>}
								</CurrentScale>

								<ZoomIn>
									{(props) => (
										<Tooltip title="zoom in" placement="top">
											<IconButton sx={{ width: '24px', height: '24px', fontSize: 'inherit' }} onClick={props.onClick}>
												<ZoomInOutlined />
											</IconButton>
										</Tooltip>
									)}
								</ZoomIn>
							</Box>
						</Stack>

						<Box sx={{ pr: 1, display: 'flex', gap: '5px', alignItems: 'center' }}>
							{/* <EnterFullScreen>
								{(props) => (
									<Tooltip title="Full Screen" placement="top">
										<IconButton sx={{ width: '24px', height: '24px', fontSize: 'inherit' }} onClick={props.onClick}>
											<FullscreenOutlined />
										</IconButton>
									</Tooltip>
								)}
							</EnterFullScreen> */}
							{filesDownloadAccess && (
								<>
									<Download>
										{(props) => (
											<Tooltip title="Download" placement="top">
												<IconButton sx={{ width: '24px', height: '24px', fontSize: 'inherit' }} onClick={props.onClick}>
													<DownloadOutlined />
												</IconButton>
											</Tooltip>
										)}
									</Download>

									<Print>
										{(props) => (
											<Tooltip title="Print" placement="top">
												<IconButton sx={{ width: '24px', height: '24px', fontSize: 'inherit' }} onClick={props.onClick}>
													<PrinterOutlined />
												</IconButton>
											</Tooltip>
										)}
									</Print>
								</>
							)}
						</Box>
					</Stack>
				</Box>
				<div
					style={{
						flex: 1,
						overflow: 'hidden',
					}}
				>
					<Viewer
						fileUrl={fullURL}
						plugins={[
							zoomPluginInstance,
							pageNavigationPluginInstance,
							printPluginInstance,
							getFilePluginInstance,
							fullScreenPluginInstance,
						]}
						httpHeaders={{
							token: `Bearer ${accessToken}`,
						}}
					/>
				</div>
			</Stack>
		</Worker>
	);
};

export default PDFViewer;

// export const PDFViewer = ({ url, fileName, filesDownloadAccess, accessToken }) => {
// 	const inputRef = useRef();

// 	const toolbarPluginInstance = toolbarPlugin();
// 	const printPluginInstance = printPlugin();
// 	const fullScreenPluginInstance = fullScreenPlugin();
// 	const getFilePluginInstance = getFilePlugin({
// 		fileNameGenerator: (file) => {
// 			// Safely get the default name if the prop is missing
// 			const defaultFileName = file?.name ? file?.name.substring(file?.name?.lastIndexOf('/') + 1) : 'document.pdf';
// 			return fileName || defaultFileName;
// 		},
// 	});

// 	const { Toolbar } = toolbarPluginInstance;
// 	const { Print } = printPluginInstance;
// 	const { Download } = getFilePluginInstance;
// 	const { EnterFullScreen } = fullScreenPluginInstance;

// 	useEffect(() => {
// 		if (inputRef?.current) {
// 			const inputElement = inputRef?.current?.querySelector('input');

// 			if (inputElement) {
// 				inputElement?.setAttribute('id', 'currentPageInput');
// 			}
// 		}
// 	}, []);

// 	if (!url) {
// 		return null;
// 	}

// 	return (
// 		<Worker workerUrl={`https://${DEPLOYENVIRONMENT === '' ? 'www.' : DEPLOYENVIRONMENT}garlicerp.com/pdf.worker.min.js`}>
// 			<Stack
// 				sx={{
// 					width: '100%',
// 					height: '100%',
// 				}}
// 			>
// 				<Box
// 					sx={{
// 						width: '100%',
// 						padding: '8px 4px',
// 						backgroundColor: '#eeeeee',
// 						borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
// 						// minWidth: "500px",
// 						fontSize: '14px',
// 					}}
// 				>
// 					<Toolbar>
// 						{(props) => {
// 							const { CurrentPageInput, CurrentScale, NumberOfPages, ZoomIn, ZoomOut } = props;
// 							return (
// 								<Stack direction="row" alignItems="center" justifyContent={filesDownloadAccess ? 'space-between' : 'center'}>
// 									<Box></Box>
// 									<Stack direction="row" divider={<Divider orientation="vertical" flexItem />}>
// 										<Box sx={{ px: 1, display: 'flex', alignItems: 'center' }} ref={inputRef}>
// 											<CurrentPageInput />
// 											<Box sx={{ mx: '4px' }}>/</Box>
// 											<Box sx={{ mx: '4px' }}>
// 												<NumberOfPages />
// 											</Box>
// 										</Box>

// 										{/* </Box> */}
// 										<Box sx={{ px: 1, display: 'flex', alignItems: 'center' }}>
// 											<ZoomOut>
// 												{(props) => (
// 													<Tooltip title="zoom out" placement="top">
// 														<IconButton
// 															sx={{ width: '24px', height: '24px', fontSize: 'inherit' }}
// 															onClick={props.onClick}
// 														>
// 															<ZoomOutOutlined />
// 														</IconButton>
// 													</Tooltip>
// 												)}
// 											</ZoomOut>
// 											<CurrentScale>
// 												{(props) => <Box component="span" sx={{ px: '5px' }}>{`${Math.round(props.scale * 100)}%`}</Box>}
// 											</CurrentScale>
// 											<ZoomIn>
// 												{(props) => (
// 													<Tooltip title="zoom in" placement="top">
// 														<IconButton
// 															sx={{ width: '24px', height: '24px', fontSize: 'inherit' }}
// 															onClick={props.onClick}
// 														>
// 															<ZoomInOutlined />
// 														</IconButton>
// 													</Tooltip>
// 												)}
// 											</ZoomIn>
// 										</Box>
// 									</Stack>

// 									<Box sx={{ pr: 1, display: 'flex', gap: '5px', alignItems: 'center' }}>
// 										<EnterFullScreen>
// 											{(props) => (
// 												<Tooltip title="Full Screen" placement="top">
// 													<IconButton sx={{ width: '24px', height: '24px', fontSize: 'inherit' }} onClick={props.onClick}>
// 														<FullscreenOutlined />
// 													</IconButton>
// 												</Tooltip>
// 											)}
// 										</EnterFullScreen>
// 										{filesDownloadAccess && (
// 											<>
// 												<Download>
// 													{(props) => (
// 														<Tooltip title="Download" placement="top">
// 															<IconButton
// 																sx={{ width: '24px', height: '24px', fontSize: 'inherit' }}
// 																onClick={props.onClick}
// 															>
// 																<DownloadOutlined />
// 															</IconButton>
// 														</Tooltip>
// 													)}
// 												</Download>

// 												<Print>
// 													{(props) => (
// 														<Tooltip title="Print" placement="top">
// 															<IconButton
// 																sx={{ width: '24px', height: '24px', fontSize: 'inherit' }}
// 																onClick={props.onClick}
// 															>
// 																<PrinterOutlined />
// 															</IconButton>
// 														</Tooltip>
// 													)}
// 												</Print>
// 											</>
// 										)}
// 									</Box>
// 								</Stack>
// 							);
// 						}}
// 					</Toolbar>
// 				</Box>
// 				<Box
// 					sx={{
// 						flex: 1,
// 						overflow: 'hidden',
// 					}}
// 				>
// 					<Viewer
// 						fileUrl={url}
// 						plugins={[toolbarPluginInstance, printPluginInstance, getFilePluginInstance, fullScreenPluginInstance]}
// 						httpHeaders={{
// 							token: `Bearer ${accessToken}`,
// 						}}
// 					/>
// 				</Box>
// 			</Stack>
// 		</Worker>
// 	);
// };
